import React from "react";
import { Link } from "react-router-dom";
const getUserColumns = (deleteAccount) => {
  return [
    {
      title: "S.No",
      dataIndex: "id",
      render: (text, record, index) => index + 1,
      sorter: (a, b) => a.id.length - b.id.length,
      width: "10%",
    },
    {
      title: "Name",
      dataIndex: "firstName" + "surname",
      render: (_, record) => `${record.firstName} ${record.surname}`,
      width: "15%",
    },
    {
      title: "Email",
      dataIndex: "email",
      width: "15%",
    },
    {
      title: "User ID",
      dataIndex: "id",
      width: "15%",
    },
    {
      title: "Transactions Count",
      dataIndex: "transactionCount",
      render: (transactionCount, record) => (
        <Link to={`/ChargingHistory/${record?.id}`}>{transactionCount}</Link>
      ),
      width: "15%",
    },
    {
      title: "Cards Count",
      dataIndex: "cardCount",
      render: (cardCount, record) => (
        <Link to={`/cards/${record?.id}`}>{cardCount}</Link>
      ),
      width: "15%",
    },
    {
      title: "Status",
      dataIndex: "deletedAt",
      render: (deletedAt) => (deletedAt !== null ? "Deleted" : "Active"),
      width: "15%",
    },
    {
      title: "Action",
      className: "text-end",
      render: (text, record) => {
        const isActive = record?.deletedAt === null;

        return (
          <button
            style={{
              backgroundColor: isActive ? "green" : "gray",
              cursor: isActive ? "pointer" : "not-allowed",
              color: "white",
              padding: "4px 10px",
              border: "none",
              borderRadius: "4px",
              width: "auto",
              display: "inline-block",
            }}
            disabled={!isActive}
            onClick={() =>
              deleteAccount({
                userId: record?.id,
              })
            }
          >
            Delete
          </button>
        );
      },
      width: "15%",
    },
  ];
};

export default getUserColumns;
